/* eslint-disable */
import { FuseNavigationItem } from "@fuse/components/navigation";
import { Constants } from "app/core/constants/constants";
import { AppContextModel } from "app/shared/models/context.model";

export const defaultNavigation: FuseNavigationItem[] = [
  /** global routes */
  {
    id: Constants.folderIdRoute,
    type: "group",
    context: AppContextModel.globalContext,
    children: [
      {
        id: "dashboard",
        title: "nav.dashboard_title",
        type: "basic",
        link: Constants.dashboardRoute,
        context: AppContextModel.globalContext,
        moduleCodeName: Constants.dashboardModule,
        icon: "heroicons_outline:dashboard",
        classes: {
          icon: ["bg-[#1F9CFF]"],
        },
      },
      {
        id: Constants.crudFolderIdRoute,
        title: "nav.folder_title",
        type: "basic",
        icon: "heroicons_outline:folder",
        context: AppContextModel.globalContext,
        exactMatch: true,
        classes: {
          icon: ["bg-[#AC25C3]"],
        },
      },
      {
        id: "organization",
        title: "nav.organization_title",
        type: "collapsable",
        icon: "heroicons_outline:organisation",
        classes: {
          icon: ["bg-[#0ED11C]"],
        },
        context: AppContextModel.globalContext,
        moduleCodeName: Constants.organisationModule,
        children: [
          {
            id: "establishment",
            title: "nav.establishment_title",
            type: "basic",
            moduleCodeName: Constants.establishmentModule,
            link: Constants.establishmentManagementRoute,
          },
          {
            id: "organization_chart",
            title: "nav.organization_chart_title",
            type: "basic",
            moduleCodeName: Constants.organisationModule,
            link: Constants.levelManagementRoute,
          },
          {
            id: "rank_management",
            title: "nav.rank_management_title",
            type: "basic",
            moduleCodeName: Constants.rankModule,
            link: Constants.rankManagementRoute,
          },
          {
            id: "salary_management",
            title: "nav.salary_management_title",
            type: "basic",
            moduleCodeName: Constants.salaryModule,
            link: Constants.salaryManagementRoute,
          },
        ],
      },
      {
        id: 'onboarding',
        title: 'nav.onboarding_title',
        type: 'collapsable',
        icon: 'heroicons_outline:persons_add',
        classes: {
          icon: ['bg-[#ffd400]'],
        },
        context: AppContextModel.globalContext,
        moduleCodeName: Constants.onboardingModule,
        children: [
          {
            id: 'job_opening',
            title: 'nav.job_opening_title',
            type: 'basic',
            moduleCodeName: Constants.onboardingModule,
            link: `${Constants.onboardingRoute}/${Constants.jobOpeningRoute}`,
          },
          {
            id: "integration_process",
            title: "nav.integration_process_title",
            type: "basic",
            moduleCodeName: Constants.onboardingModule,
            link: `${Constants.onboardingRoute}/${Constants.integrationProcessRoute}`,
          },
          {
            id: "employees_integration_process",
            title: "nav.employees_integration_process_title",
            type: "basic",
            moduleCodeName: Constants.onboardingModule,
            link: `${Constants.onboardingRoute}/${Constants.employeesIntegrationProcessRoute}`,
          },
        ]
      },
      {
        id: "employees",
        title: "nav.employees_title",
        type: "collapsable",
        icon: "heroicons_outline:employees",
        classes: {
          icon: ["bg-[#FF7100]"],
        },
        context: AppContextModel.globalContext,
        moduleCodeName: Constants.employeeModule,
        children: [
          {
            id: "employees_list",
            title: "nav.employees_list_title",
            type: "basic",
            moduleCodeName: Constants.employeeModule,
            link: Constants.employeesRoute,
            queryParamsHandling: 'merge',
            isActiveMatchOptions: {
              fragment: 'ignored',
              matrixParams: 'ignored',
              paths: 'exact',
              queryParams: 'ignored',
            },
          },
          {
            id: "employees_group",
            title: "nav.employees_group_title",
            type: "basic",
            moduleCodeName: Constants.employeeModule,
            link: `${Constants.employeesRoute}/${Constants.employeesGroupRoute}`,
          },
        ],
      },
      {
        id: "time_management",
        title: "nav.time_management_title",
        type: "collapsable",
        icon: "heroicons_outline:time",
        classes: {
          icon: ["bg-[#495DCF]"],
        },
        context: AppContextModel.globalContext,
        moduleCodeName: Constants.pointingModule,
        children: [
           {
            id: "shifts",
            title: "nav.shifts_title",
            type: "basic",
            moduleCodeName: Constants.shiftsModule,
            link: Constants.shiftsRoute,
          },
          {
            id: "check_in",
            title: "nav.check_in_title",
            type: "basic",
            moduleCodeName: Constants.pointingModule,
            link: Constants.pointingRoute,
          },
          {
            id: "planning",
            title: "nav.planning_title",
            type: "basic",
            moduleCodeName: Constants.pointingModule,
            link: Constants.planningRoute,
          },
          {
            id: "check_in_zone",
            title: "nav.check_in_zone_title",
            type: "basic",
            moduleCodeName: Constants.pointingModule,
            link: Constants.qrCodeRoute,
          }
        ],
      },

      {
        id: Constants.absenceExitRouteId,
        title: "nav.absence_exit_title",
        type: "collapsable",
        icon: "heroicons_outline:absence",
        classes: {
          icon: ["bg-[#FF392A]"],
        },
        context: AppContextModel.globalContext,
        moduleCodeName: Constants.absenceModule,
        children: [
          {
            id: Constants.absenceRouteId,
            title: "nav.absence_title",
            type: "basic",
            moduleCodeName: Constants.absenceModule,
            link: Constants.absenceRoute,
          },
          {
            id: Constants.exitRouteId,
            title: "nav.exit_title",
            type: "basic",
            moduleCodeName: Constants.exitModule,
            link: Constants.exitRoute,
          },
        ],
      },

      {
        id: Constants.absenceRouteId,
        title: "nav.absence_title",
        type: "basic",
        icon: "heroicons_outline:absence",
        classes: {
          icon: ["bg-[#FF392A]"],
        },
        link: Constants.absenceRoute,
        context: AppContextModel.globalContext,
        moduleCodeName: Constants.absenceModule,
      },

      {
        id: Constants.leaveRouteId,
        title: "nav.leave_title",
        type: "basic",
        link: Constants.leaveRoute,
        icon: "heroicons_outline:leave",
        classes: {
          icon: ["bg-[#D93A8E]"],
        },
        context: AppContextModel.globalContext,
        moduleCodeName: Constants.leaveModule,
      },

      {
        id: Constants.leaveRecoveryRouteId,
        type: "collapsable",
        title: "nav.leave_recovery_title",
        icon: "heroicons_outline:leave",
        classes: {
          icon: ["bg-[#D93A8E]"],
        },
        children: [
          {
            id: "leave",
            title: "nav.leave_title",
            type: "basic",
            link: Constants.leaveRoute,
            context: AppContextModel.globalContext,
            moduleCodeName: Constants.leaveModule,
          },
          {
            id: Constants.recoveryRouteId,
            title: "nav.recovery_title",
            type: "basic",
            link: Constants.recoveryRoute,
            context: AppContextModel.globalContext,
            moduleCodeName: Constants.recoveryModule,
          },
        ],
      },

      {
        id: Constants.requisitionRoute,
        title: "nav.requisition_title",
        type: "basic",
        icon: "heroicons_outline:clipboard-document-list",
        classes: {
          icon: ["bg-[#00B294]"],
        },
        link: Constants.requisitionRoute,
        context: AppContextModel.globalContext,
        moduleCodeName: Constants.requisitionModule,
      },

      {
        id: Constants.missionRouteId,
        title: "nav.mission_title",
        type: "basic",
        icon: "heroicons_outline:mission",
        classes: {
          icon: ["bg-[#EC7063]"],
        },
        link: Constants.missionsRoute,
        context: AppContextModel.globalContext,
        moduleCodeName: Constants.missionModule,
      },
      {
        id: Constants.payementRouteId,
        title: "nav.payement_title",
        type: "collapsable",
        icon: "heroicons_outline:payroll",
        classes: {
          icon: ["bg-[#FF9800]"],
        },
        context: AppContextModel.globalContext,
        moduleCodeName: Constants.payModule,
        children: [
          {
            id: "rubric",
            title: "nav.rubric_title",
            type: "basic",
            moduleCodeName: Constants.rubricModule,
            link: Constants.rubricRoute,
          },
          {
            id: "payroll",
            title: "nav.payroll_title",
            type: "basic",
            moduleCodeName: Constants.payModule,
            link: Constants.payrollRoute,
          },
          {
            id: "payReport",
            title: "nav.pay_report_title",
            type: "basic",
            moduleCodeName: Constants.payReportModule,
            link: Constants.payReportRoute,
          },
          {
            id: Constants.loanRouteId,
            title: "nav.loan_management_title",
            type: "basic",
            moduleCodeName: Constants.payModule,
            link: Constants.loanRoute,
          },
          {
            id: Constants.feesRouteId,
            title: "nav.fees_title",
            type: "basic",
            moduleCodeName: Constants.feesModule,
            link: Constants.feesRoute,
          },
          {
            id: "advanced_payment",
            title: "nav.advanced_payment_title",
            type: "basic",
            moduleCodeName: Constants.advancePaymentModule,
            link: Constants.advancedPaymentRoute,
          },
        ],
      },
      {
        id: "documents",
        title: "nav.documents_title",
        type: "collapsable",
        icon: "heroicons_outline:documents",
        classes: {
          icon: ["bg-[#215F91]"],
        },
        context: AppContextModel.globalContext,
        moduleCodeName: Constants.documentModule,
        children: [
          {
            id: "card_job",
            title: "nav.card_job_title",
            type: "basic",
            moduleCodeName: Constants.documentModule,
            link: Constants.cardJobRoute,
          },
          {
            id: "refund",
            title: "nav.refund_title",
            type: "basic",
            moduleCodeName: Constants.documentModule,
            link: Constants.redeemCnasCertificateRoute,
          },
          {
            id: "professional_cards_list",
            title: "nav.professional_cards_list_title",
            type: "basic",
            moduleCodeName: Constants.documentModule,
            link: Constants.professionalcardslistRoute,
          },
          {
            id: "new_certificate_list",
            title: "nav.new_certificate_list_title",
            type: "basic",
            moduleCodeName: Constants.documentModule,
            link: Constants.newCertificateListRoute,
          },
        ],
      },
      {
        id: "declarations",
        title: "nav.declarations_title",
        type: "collapsable",
        icon: "heroicons_outline:declaration",
        classes: {
          icon: ["bg-[#861599]"],
        },
        context: AppContextModel.globalContext,
        moduleCodeName: Constants.statementsModule,
        children: [
          {
            id: "cnas_declarations",
            title: "nav.cnas_declarations_title",
            type: "basic",
            moduleCodeName: Constants.statementsModule,
            link: Constants.cnasDeclarationsRoute,
          },
          {
            id: "cacobath_declarations",
            title: "nav.cacobath_declarations_title",
            type: "basic",
            moduleCodeName: Constants.statementsModule,
            link: Constants.cacobathDeclarationsRoute,
          },
          {
            id: "das_declarations",
            title: "nav.das_declarations_title",
            type: "basic",
            moduleCodeName: Constants.statementsModule,
            link: Constants.dasDeclarationsRoute,
          },
        ],
      },
    ],
  },

  /** administration routes */

  {
    id: "admin_client_account",
    title: "nav.admin_client_account",
    type: "basic",
    icon: "heroicons_outline:user-account",
    classes: {
      icon: ["bg-[#0ED11C]"],
    },
    context: AppContextModel.administrationContext,
    link: Constants.viewRoute,
  },
  {
    id: "admin_admins",
    title: "nav.admins",
    type: "basic",
    icon: "heroicons_outline:settings",
    classes: {
      icon: ["bg-[#AC25C3]"],
    },
    context: AppContextModel.administrationContext,
    link: Constants.adminsRoute,
  },
  {
    id: "admin_users",
    title: "nav.admin_users",
    type: "basic",
    icon: "heroicons_outline:users",
    classes: {
      icon: ["bg-[#495DCF]"],
    },
    context: AppContextModel.administrationContext,
    link: Constants.usersRoute,
  },
  {
    id: "admin_history",
    title: "nav.admin_history",
    type: "basic",
    icon: "heroicons_outline:history",
    classes: {
      icon: ["bg-[#FF7100]"],
    },
    context: AppContextModel.administrationContext,
    link: Constants.trackabilityRoute,
  },
];
export const compactNavigation: FuseNavigationItem[] = defaultNavigation;
export const futuristicNavigation: FuseNavigationItem[] = defaultNavigation;
export const horizontalNavigation: FuseNavigationItem[] = defaultNavigation;
